import type { FunctionComponent } from 'react';
import { useSchoolPageBySlugTabContentQuery } from '../../../../graphql/useSchoolPageBySlugTabContentQuery';
import { isContentOverview } from '../../../../helpers/isContentOverview';
import { SchoolCatchmentDisclaimerBrick } from './SchoolCatchmentDisclaimerBrick';

export const SchoolCatchmentDisclaimerBrickWithData: FunctionComponent = () => {
  const { data } = useSchoolPageBySlugTabContentQuery();
  const tabContent = data?.schoolPageBySlug?.tabContent;
  if (!tabContent || !isContentOverview(tabContent)) return null;

  const { catchmentDisclaimer } = tabContent;
  if (!catchmentDisclaimer) return null;

  return <SchoolCatchmentDisclaimerBrick disclaimerText={catchmentDisclaimer.text} />;
};
